// Generated from api/openapi/agents.yaml by make docs. Do not edit.
import { z } from "zod";

export const agentConsentPolicySchema = z.object({
  "require_maker_checker": z.boolean(),
  "maker_checker_threshold": z.number().int().min(0).nullable(),
  "reconsent_deadline": z.string().datetime({ offset: true }).nullable(),
  "configured": z.boolean()
}).strict();
